export type Provider = 'google' | 'stripe' | 'zoom' | 'outlook';

export interface OAuth2AuthorizeResponse {
  url: string;
}

export interface ProviderStatus {
  connected: boolean;
  lastError: string | null;
}
export interface OAuth2ConnectionsResponse {
  google: ProviderStatus;
  stripe: ProviderStatus;
  zoom: ProviderStatus;
  outlook: ProviderStatus;
}

export interface OAuth2Mixin {
  fetch(path: string, init?: RequestInit): Promise<any>;
  oAuth2Authorize(provider: Provider): Promise<OAuth2AuthorizeResponse>;
  oAuth2Connections(): Promise<OAuth2ConnectionsResponse>;
  oAuth2Delete(provider: Provider): Promise<undefined>;
}

export const OAuth2Mixin = {
  async fetch(path: string, init?: RequestInit): Promise<any> {
    throw new Error('Not implemented');
  },
  async oAuth2Authorize(provider: Provider): Promise<OAuth2AuthorizeResponse> {
    const sess = (await this.fetch(`/oauth2/${provider}/authorize`)) as OAuth2AuthorizeResponse;
    return sess;
  },
  async oAuth2Connections(): Promise<OAuth2ConnectionsResponse> {
    const conns = (await this.fetch('/oauth2/connections')) as OAuth2ConnectionsResponse;
    return conns;
  },
  async oAuth2Delete(provider: Provider): Promise<undefined> {
    await this.fetch(`/oauth2/${provider}`, {
      method: 'DELETE',
    });
  },
} as OAuth2Mixin;
